console.log("ALL IS OK");

  jQuery(function () {
    jQuery(document).ready(function () {
      // Parse the URL
      getParameterByName = function(name) {
          query = window.location.search.toString();
          name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
          var regexS = "[\\?&]" + name + "=([^&#]*)";
          var regex = new RegExp(regexS);
          results = regex.exec(query);
          if (results === null) return "";
          else return decodeURIComponent(results[1].replace(/\+/g, " "));
      }
      
      var pId = __st.rid;
      const quantityInput = jQuery('input[name="quantity"]');
      
      if(jQuery("#wcp_json_" + pId).length > 0){
        var productObj = JSON.parse(jQuery("#wcp_json_" + pId).html());
        console.log("productObj => ", productObj.variants);
        var productTitle = productObj.title;
        if (productTitle.toLowerCase().includes("black mark")) {
          quantityInput.val(3);
          quantityInput.attr("min", 3);
        } else {
          quantityInput.val(1);
          quantityInput.attr("min", 1);
        }

        var currVid = getParameterByName('variant');
        if(currVid){
          quantityInput.val(1);
          quantityInput.attr("min", 1);
          
          var productVari = productObj.variants
          for (var i = 0; i < productVari.length; i++) {
            if(productVari[i]['id'] == currVid){
              var currVtitle = productVari[i]['title'];
              if (currVtitle.toLowerCase().includes("black mark")) {
                quantityInput.val(3);
                quantityInput.attr("min", 3);
              }
            }
          }
        }
      }
      
      jQuery('select[name="id"]').change(function () {

        quantityInput.val(1);
        quantityInput.attr("min", 1);
        const selectedOption = jQuery(this).find("option:selected").text();
        if (selectedOption.toLowerCase().includes("black mark")) {          
          const currentQuantity = parseInt(quantityInput.val());
          if (currentQuantity < 3) {
            quantityInput.val(3);
            alert(
              'Due to extra labor to produce "Black Mark" labels, there is a minimum order of 3 rolls and a $15 charge per roll'
            );
            quantityInput.attr("min", 3);
          }
        }
      });

      quantityInput.on('keyup', function(){
        if(parseInt(quantityInput.val()) < parseInt(quantityInput.attr('min'))){
          quantityInput.val(quantityInput.attr('min'));
        }
      });
      quantityInput.parent().find('button').on('click', function(){
        if(parseInt(quantityInput.val()) < parseInt(quantityInput.attr('min'))){
          quantityInput.val(quantityInput.attr('min'));
        }
      });
    });
  });
